import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';

const PaymentFailed: React.FC = () => {
  const [params] = useSearchParams();
  const status = (params.get('status') || 'failed').trim();

  return (
    <div className="container">
      <div className="card" style={{ maxWidth: '760px', margin: '40px auto' }}>
        <span className="badge red">Payment Failed</span>
        <h1 className="h1" style={{ marginTop: '10px' }}>Payment could not be completed</h1>
        <p className="muted">
          Please try again. If the amount was debited and status is pending, wait for the gateway update.
        </p>
        <p className="muted">Status: {status}</p>

        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginTop: '14px' }}>
          <Link className="btn" to="/pricing">Try Again</Link>
          <Link className="btn ghost" to="/help">Contact Support</Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailed;
